import React from 'react'
import { Helmet } from 'react-helmet'
import imageBanner from 'scripts/config/ImageBanner'
import { eventTriggerGA } from 'scripts/lib/utils'
import Constants from 'scripts/base/Constants'
import {getLang} from 'shared/i18n/react'

const Metas = (props) => {
  const {id, name, pageURL, ssr, pageTitle} = props
  const lang = getLang()
  const listingURL = !ssr ? window.location.href : pageURL
  const banner = (id) ? imageBanner[lang][id] : null
  const imageURL = banner || imageBanner[lang]['default']
  const theTitle = (name || pageTitle) + ' | Soompi'
  const { StaticStructHome, StaticStructSearch } = Constants.MetaDefaults

  return (
    <Helmet onChangeClientState={eventTriggerGA}>
      <title defer={false}>{theTitle}</title>
      <link rel="canonical" href={listingURL} />
      <meta name="title" content={theTitle} />
      <meta property="og:url" content={listingURL} />
      <meta property="og:image" content={`${imageURL}?s=900x600&e=t`} />
      <meta property="og:title" content={theTitle}/>
      <meta name="twitter:title" content={theTitle} />
      <meta name="twitter:image" content={`${imageURL}?s=900x600&e=t`} />
      <script type="application/ld+json">{StaticStructHome[lang]}</script>
      <script type="application/ld+json">{StaticStructSearch[lang]}</script>
    </Helmet>
  )
}

export default Metas



// WEBPACK FOOTER //
// ./assets/js/components/listings/Metas.jsx